import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import BrokerFAQ from 'components/broker/BrokerFAQ'
import { ArticleJsonLd } from 'components/shared/schema/article'
import { Broker_FaqDocument } from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import { PAGE_SIZE_FOR_PAGINATION } from 'shared/constants'
import { pageUri } from 'shared/util'
import { initializeApollo, addApolloState } from 'util/apolloClient'

const title = ({ broker, page }) => {
  return `Frequently asked questions about ${broker.name} - Page ${page || 1}`
}

const description = ({ broker }) => {
  return `${broker.name} Frequently asked questions (FAQ). As queries about ${broker.name}`
}

export default function Broker(props) {
  const router = useRouter()
  const { asPath } = router
  const { data: brokerData, page } = props

  const {
    brokers,
    all_brokers: { data: allBrokers },
    nav_calculators: { data: navCalculators },
    all_pages: { data: allPages },
  } = brokerData

  const broker = brokers.data[0].attributes
  const pageTitle = title({ broker, page })
  const pageDescription = description({ broker })
  const urlWithoutPage = pageUri(`/broker/${broker.slug}/faq`)
  const country = {
    attributes: { name: brokers.data[0].attributes.country.name },
  }
  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
      country={country}
    >
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        {page === 1 && <link rel="canonical" href={urlWithoutPage} />}
      </Head>
      <ArticleJsonLd
        url={pageUri(asPath)}
        title={pageTitle}
        description={pageDescription}
      />
      <BrokerFAQ broker={broker} allBrokers={allBrokers} />
    </ApplicationLayout>
  )
}

export async function getServerSideProps({ params }) {
  const apolloClient = initializeApollo()

  const { page = 0, slug } = params

  const start = page > 1 ? (page - 1) * PAGE_SIZE_FOR_PAGINATION : 0

  const { data } = await apolloClient.query({
    query: Broker_FaqDocument,
    variables: { slug, start, limit: PAGE_SIZE_FOR_PAGINATION },
  })

  return addApolloState(apolloClient, {
    props: { data, page },
  })
}
